(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('config', {
                    parent: 'app.private',
                    url: '/config',
                    data: {
                        pageTitle: 'systemConfig.title'
                    },
                    views: {
                        'content@app.private': {
                            templateUrl: 'app/components/config/config.html',
                            controller: 'SystemConfigController',
                            controllerAs: 'vmSystemConfig'
                        },
                        'smtp@config': {
                            templateUrl: 'app/components/config/config-smtp.html'
                        },
                        'access-control@config': {
                            templateUrl: 'app/components/config/config-access-control.html'
                        },
                        'backup@config': {
                            templateUrl: 'app/components/backup-db/backup.html'
                        },
                        'user-list@config': {
                            templateUrl: 'app/components/user/user-list.html',
                            controller: 'UserListController',
                            controllerAs: 'vmUserList'
                        },
                        'user-password@config': {
                            templateUrl: 'app/components/user/user-change-password.html',
                            controller: 'UserChangePasswordController',
                            controllerAs: 'vmUserChangePassword'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('user');
                                $translatePartialLoader.addPart('user-modals');
                                $translatePartialLoader.addPart('config');
                                return $translate.refresh();
                            }]
                    }
                })
    }

})();
